/* start - flights_split_bounds_us */
import { List } from "@bookingcom/bui-react";
import { UIFlightData } from "@flights/types";
import React from "react";
import FlightCardBound from "../FlightCard/components/FlightCardBound.desktop";
import { isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
import Frame from "../Frame";
import { FlightCampaignTCBanner } from "../FlightCampaignTCBanner";
import { RemoteAppleCardSR } from "../../remote";
import GeniusTCBanner from "../../../cross-sell/components/GeniusTCBanner";
import { SearchTrafficAAGeniusTrackerDesktop } from "./SearchResults.desktop";
import useSearchResultsListDesktopController from "./useSearchResultsList.desktop.controller";
import FlightCardWrapper from "./FlightCardWrapper";

type Props = {
  flights: UIFlightData[];
  onSelectFlight: (flight: UIFlightData) => void;
};

const SearchResultsListOutboundDesktop = ({ flights, onSelectFlight }: Props) => {
  const { campaignBanner, remoteBanners, searchType } = useSearchResultsListDesktopController();

  return (
    <List attributes={{ style: { padding: 0 } }}>
      {flights.map((flight, index) => {
        return (
          <div key={`${index}_${flight.token}`}>
            {isFeatureRunningClientSide("FLIGHTS_PRICING_ENABLE_WHITE_LABEL_TC_BANNER_IN_FE") &&
            campaignBanner &&
            index === campaignBanner.position ? (
              <Frame mt={2} mb={4}>
                <FlightCampaignTCBanner campaignBanner={campaignBanner} />
              </Frame>
            ) : null}

            {Array.isArray(remoteBanners) &&
            remoteBanners.includes("APPLE_CARD_BANNER_SR") &&
            index === flights.length - 1 ? (
              <RemoteAppleCardSR />
            ) : undefined}

            <FlightCardWrapper index={index}>
              <FlightCardBound
                flight={flight}
                onClick={onSelectFlight}
                pricePerPerson
                index={index}
                searchType={searchType}
                boundsVariant="outbound"
              />
            </FlightCardWrapper>

            {/* If GeniusCampaign is Enabled, show the Genius TC campaign on 3rd position */}
            {!isFeatureRunningClientSide("FLIGHTS_PRICING_ENABLE_WHITE_LABEL_TC_BANNER_IN_FE") &&
            index === 1 &&
            campaignBanner ? (
              <Frame mt={2} mb={4}>
                <GeniusTCBanner campaignBanner={campaignBanner} />
                <SearchTrafficAAGeniusTrackerDesktop />
              </Frame>
            ) : null}

            {/**
             * If the position is larger than the number of cards displayed in the SR page,
             * then the T&C banner is shown after the last card.
             * More info: https://jira.booking.com/jira/browse/FPRICING-809
             */}
            {isFeatureRunningClientSide("FLIGHTS_PRICING_ENABLE_WHITE_LABEL_TC_BANNER_IN_FE") &&
            campaignBanner &&
            campaignBanner.position >= flights.length && // campaign banner position is larger than the number of cards
            index >= flights.length - 1 ? ( // after the last flight card
              <Frame mt={2} mb={4}>
                <FlightCampaignTCBanner campaignBanner={campaignBanner} />
              </Frame>
            ) : null}
          </div>
        );
      })}{" "}
    </List>
  );
};

export default React.memo(SearchResultsListOutboundDesktop);
/* end - flights_split_bounds_us */
